export class Title extends Phaser.GameObjects.Container {

    private redSnake: Phaser.GameObjects.Image;
    private blueSnake: Phaser.GameObjects.Image;
    private ladder: Phaser.GameObjects.Image;
    private title: Phaser.GameObjects.Image;
    private logo: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.y = -100;
        this.x = -20;

        this.redSnake = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "logo_05");
        this.add(this.redSnake); 

        this.scene.tweens.add({
            targets: this.redSnake,
            scaleX: 1.05,
            scaleY: 1,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 600,
            yoyo: true,
            repeat: -1
        });

        this.ladder = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "logo_04");
        this.add(this.ladder); 

        this.blueSnake = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "logo_03");
        this.add(this.blueSnake); 

        this.scene.tweens.add({
            targets: this.blueSnake,
            scaleX: 1.05,
            scaleY: 1,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 400,
            delay: 500,
            yoyo: true,
            repeat: -1
        });

        this.title = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "logo_02");
        this.add(this.title); 

        this.scene.tweens.add({
            targets: this.title,
            scaleX: 1.05,
            scaleY: .95,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 500,
            yoyo: true,
            repeat: -1
        });

        this.logo = new Phaser.GameObjects.Image(this.scene, 20, -20, "texture_atlas_1", "logo_01");
        this.logo.setInteractive({pixelPerfect: true});
        this.logo.on("pointerdown", this.logoTween, this);
        this.add(this.logo);
    }

    private logoTween(): void {

        this.scene.tweens.add({
            targets: this.logo,
            angle: 360,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500
        });
    }
}
